import React from "react";
import ReactDOM from "react-dom/client";
// @oxbo/tokens injects the three-layer theming CSS on import (must be first).
import "@oxbo/tokens";
// The Oxbo-Z P3 kit — component classes (.card/.btn/.dt/.badge/.chip-ctx/.ic-*,
// --op-* operation colors, data-palette). Used verbatim across the W screens.
import "@oxbo/tokens/_kit.css";
import "./components/shell/shell.css";
import { Providers } from "@app/providers";
import { AppRouter } from "@app/router";
import { startMocks } from "./mocks/browser";
import { initDevAuth } from "@api/devAuth";
import { initProdAuth, getProdOrgRoles, isProdAuthEnabled } from "@api/prodAuth";
import { store } from "@app/store";
import { setRole } from "@app/slices/prefsSlice";

async function bootstrap() {
  // Standalone mode: MSW serves synthetic M/P data so the app runs with no backend.
  await startMocks();

  // Real-backend dev mode: mint the first Oxbo-M JWT before render and arm the
  // ~15-min refresh loop. No-op unless VITE_DEV_AUTH=true.
  await initDevAuth();

  // Real-login prod mode: log the demo user into the prod IdP before render and
  // arm the refresh loop. No-op unless VITE_PROD_AUTH=true.
  await initProdAuth();

  // Surface the demo user's data-admin capability so the (admin-only) data-lineage
  // overlay is reachable in the demo. Derived from the token's org_roles claim.
  if (isProdAuthEnabled()) {
    const roles = getProdOrgRoles();
    if (roles.includes("data_admin") || roles.includes("owner")) {
      store.dispatch(setRole("data_admin"));
    }
  }

  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("Failed to find the root element");

  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <Providers>
        <AppRouter />
      </Providers>
    </React.StrictMode>,
  );
}

void bootstrap();
